<template>


    <section> 
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/a_half_forgotten_dream.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  

                        <h1>
                            Please select your artistic category
                        </h1>
                        <base-input name="Art category" rules="required">
                                                <el-select v-model="currentSnapWizard.category" filterable placeholder="Category"
                                                    rules="required">
                                                    <el-option v-for="option in categories" :key="option.label"
                                                        :label="option.label" :value="option.value">
                                                    </el-option>
                                                </el-select>
                                            </base-input>

                        <h1>
                            Please select your country of origin
                        </h1>
                        <base-input name="Country of Origin" rules="required">
                                                <el-select v-model="currentSnapWizard.country_name" filterable placeholder="Country"
                                                    rules="required">
                                                    <el-option v-for="option in countries" :key="option.label"
                                                        :label="option.label" :value="option.value">
                                                    </el-option>
                                                </el-select>
                                            </base-input>

                        <h1>
                            Where are you located ? 
                        </h1>
                        <base-input prepend-icon="fas fa-globe" placeholder="Your location" v-model="currentSnapWizard.artist_location" name="Artist location" rules="required|alpha_spaces"></base-input>




                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
    
    
    
    
    
    </template>
    
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'

export default {
    name: 'snap03',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            loading: false,
            categories: [
                { value: "Architectural", label: "Architectural" },
                { value: "Fashion", label: "Fashion" },
                { value: "Fine Art", label: "Fine Art" },
                { value: "Landscape", label: "Landscape" },
                { value: "Nude", label: "Nude" },
                { value: "Portrait", label: "Portrait" },
                { value: "Street", label: "Street" },
                { value: "Other", label: "Other" },
            ],
            countries: [],
        }
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        fetchCountries(){
            //this.countries = $api.getCountries();
            this.loading = true;
            this.$api.getCountries()
            .then((response) => {
                const countries = response.data;
                this.countries = countries.countries;
                console.log(this.countries);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        allDataValidated: function () {
            console.log("current category -> ");
            console.log(this.currentSnapWizard.category);
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
            if (
                this.currentSnapWizard.country_name != "" && this.currentSnapWizard.country_name != undefined && this.currentSnapWizard.category != "" && this.currentSnapWizard.category != undefined && this.currentSnapWizard.artist_location != "" && this.currentSnapWizard.artist_location != undefined
            ) {
                //this.claim.allValidated = true;
                
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
        this.fetchCountries();
    }
};
</script>